export default "__VITE_ASSET__HSxNb1cV__"